"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunLotteryRequest = void 0;
var RunLotteryRequest = /** @class */ (function () {
    function RunLotteryRequest() {
    }
    return RunLotteryRequest;
}());
exports.RunLotteryRequest = RunLotteryRequest;
;
//# sourceMappingURL=runLottery.request.js.map